<template>
  <div class='w-max'>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="28"
      viewBox="0 0 30 20"
    >
      <g id="Group_567" data-name="Group 567" transform="translate(-682 -169)">
        <g
          id="Rectangle_635"
          data-name="Rectangle 635"
          transform="translate(682 169)"
          fill="none"
          stroke="#4bbac9"
          stroke-width="2"
        >
          <rect width="30" height="20" rx="4" stroke="none" />
          <rect x="1" y="1" width="28" height="18" rx="3" fill="none" />
        </g>
        <g
          id="Rectangle_636"
          data-name="Rectangle 636"
          transform="translate(701 186)"
          fill="#4bbac9"
          stroke="#4bbac9"
          stroke-width="1"
        >
          <rect width="6" height="3" stroke="none" />
          <rect x="0.5" y="0.5" width="5" height="2" fill="none" />
        </g>
        <path
          id="Path_391"
          data-name="Path 391"
          d="M-287.462-1920.338l4.517-3.986,4.415,3.986,6.527-6.527"
          transform="translate(976.186 2102.514)"
          fill="none"
          stroke="#4bbac9"
          stroke-width="2"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    data: Array,
  },
  data() {
    return {};
  },
};
</script>
